import React, { useState, useRef, useEffect } from 'react';
import api from '../api';
import { Pilules, ECHANGES, aujourdhui, ajouterJours, ajouterMois, jourOuvre, dateJour, messageErreur } from './commun';

// Noter un échange = trois choix et une phrase. La relance suivante est exigée
// tant que le compte est un prospect : c'est elle qui le ramène dans « Mes relances ».
export default function Noter({ compte, onEnregistre, onAnnule, autoFocus }) {
  const [type, setType] = useState('appel');
  const [note, setNote] = useState('');
  const [delai, setDelai] = useState('semaine');
  const [autreDate, setAutreDate] = useState('');
  const [action, setAction] = useState('');
  const [signe, setSigne] = useState(false);
  const [erreur, setErreur] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const zone = useRef(null);
  useEffect(() => { if (autoFocus) zone.current?.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, [autoFocus]);

  const devientClient = compte.statut === 'client' || signe;
  const j = aujourdhui();
  const dates = {
    demain: jourOuvre(ajouterJours(j, 1)),
    semaine: jourOuvre(ajouterJours(j, 7)),
    mois: jourOuvre(ajouterMois(j, 1)),
    autre: autreDate,
    aucune: null,
  };
  const options = [
    { cle: 'demain', libelle: 'Demain' },
    { cle: 'semaine', libelle: 'Dans 1 semaine' },
    { cle: 'mois', libelle: 'Dans 1 mois' },
    { cle: 'autre', libelle: 'Autre date' },
  ].concat(devientClient ? [{ cle: 'aucune', libelle: 'Pas de relance' }] : []);
  const date = dates[delai];

  const enregistrer = async (e) => {
    e.preventDefault();
    setErreur('');
    if (delai === 'autre' && !autreDate) { setErreur('Choisissez la date de relance.'); return; }
    if (delai === 'aucune' && !devientClient) { setErreur('Choisissez quand relancer.'); return; }
    setEnvoi(true);
    try {
      await api.post(`/commercial/comptes/${compte.id}/echanges`, {
        type, note, prochaine_action_le: date || null, prochaine_action: action, signe,
      });
      setNote(''); setAction(''); setSigne(false);
      onEnregistre();
    } catch (err) { setErreur(messageErreur(err, 'Enregistrement impossible.')); }
    finally { setEnvoi(false); }
  };

  return (
    <form className="noter carte" onSubmit={enregistrer} ref={zone}>
      <h2>Noter un échange</h2>
      <span className="etiquette">Qu'avez-vous fait ?</span>
      <Pilules etiquette="Type d'échange" options={ECHANGES} valeur={type} onChange={setType} className="pilules-types" />

      <label className="etiquette" htmlFor="note-echange">Ce qui s'est dit</label>
      <textarea id="note-echange" rows={3} value={note} onChange={(e) => setNote(e.target.value)}
        placeholder="Ex. : a goûté le rouge, rappeler après son inventaire. Sur téléphone, le micro du clavier permet de dicter." />

      {compte.statut !== 'client' && (
        <label className="case-signe">
          <input type="checkbox" checked={signe} onChange={(e) => { setSigne(e.target.checked); if (!e.target.checked && delai === 'aucune') setDelai('semaine'); }} />
          <span>Le client a signé</span>
        </label>
      )}

      <span className="etiquette">Prochaine relance</span>
      <Pilules etiquette="Prochaine relance" options={options} valeur={delai} onChange={setDelai} className="pilules-delais" />
      {delai === 'autre' && (
        <input type="date" value={autreDate} min={j} onChange={(e) => setAutreDate(e.target.value)} aria-label="Date de relance" className="champ-date" />
      )}
      {date && delai !== 'autre' && <span className="aide">Relance le {dateJour(date).replace(/\.$/, '')}. Un samedi ou un dimanche glisse au lundi.</span>}
      {date && (
        <input type="text" value={action} onChange={(e) => setAction(e.target.value)} maxLength={300}
          placeholder="Pour faire quoi ? Ex. : passer déposer des échantillons" aria-label="Objet de la relance" />
      )}

      {erreur && <div className="erreur">{erreur}</div>}
      <div className="noter-actions">
        {onAnnule && <button type="button" className="lien" onClick={onAnnule}>Annuler</button>}
        <button type="submit" className="bouton-grand" disabled={envoi}>{envoi ? 'Enregistrement…' : 'Enregistrer'}</button>
      </div>
    </form>
  );
}
